var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading)?_c('div',[_c('h2',[_vm._v("Loading data from Spotify")]),_c('v-progress-linear',{attrs:{"value":_vm.loadingProgress}})],1):_vm._e(),_c('album-tiles-container',{attrs:{"albums":_vm.albums}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }